import type {LocationType, LocationArg, RerouterLocation} from '../types';
import type {BaseHistory} from './base';

import invariant from 'invariant';
import {AbortError} from '../errors';
import {createServerLocation} from '../utils';


type HandleRedirect = (arg1: LocationType) => unknown;

export default class ServerHistory implements BaseHistory {
  handleRedirect: HandleRedirect | null | undefined;
  location: RerouterLocation;
  lastUrl: LocationType | null | undefined;

  constructor(location?: LocationType, onRedirect?: HandleRedirect) {
    this.location = createServerLocation(location);
    this.handleRedirect = onRedirect;
  }

  async push(_location: LocationArg) {
    // noop
  }

  async replace(location: LocationArg) {
    invariant(
      this.handleRedirect != null,
      'Cannot call `replace` without a redirect handler.',
    );
    this.handleRedirect(this.resolveLocation(location));
    throw new AbortError('Aborting due to server redirect.');
  }

  back() {
    // noop
  }
  goBack() {
    // noop
  }

  async leave() {
    // noop
  }

  addLeaveHook(): () => void {
    return () => {
      // noop
    };
  }
  removeLeaveHook() {
    // noop
  }
  addListener(): () => void {
    return () => {
      // noop
    };
  }

  resolveLocation(
    locationArg: LocationType | ((arg1: RerouterLocation) => LocationType),
  ): RerouterLocation {
    const location = createServerLocation(
      typeof locationArg === 'function'
        ? locationArg(this.location)
        : locationArg,
    );
    if (!location.pathname.startsWith('/')) {
      location.pathname = this.location.pathname + '/' + location.pathname;
    }
    return location;
  }
}
